export default __webpack_public_path__ + "static/media/avatarA1.deef7a58.png";